import useAdditionalGroupsByCompanySelect from 'modules/additional-groups/hooks/use-additional-groups-by-company-select';
import useAdditionalGroupsSelect from 'modules/additional-groups/hooks/use-additional-groups-select';
import {AdditionalProps} from 'modules/additionals/types';
import useCreateAdditionalGroupConfig from 'modules/products/hooks/use-create-additional-group-config';
import useProductDetails from 'modules/products/hooks/use-product-details';
import {
  AdditionalGroupConfigProps,
  AdditionalGroupConfigTypeEnum,
  translatedAdditionalGroupConfigProps,
} from 'modules/products/types';
import {useState} from 'react';

import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';
import toBrl from 'shared/util/to-brl';

const CreateAdditionalGroupConfig: React.FC = () => {
  const {id} = useParams();
  const productQuery = useProductDetails(id!);
  const {getSelect, getNumberInput, getSwitch, getDynamicSection} =
    useFormInputs<AdditionalGroupConfigProps>();
  const {data, isLoading} = useAdditionalGroupsByCompanySelect(
    productQuery.data?.companyId,
  );
  const [additionalGroupId, setAdditionalGroupId] = useState<string>();
  const additionals = data?.find(
    (additionalGroup) => additionalGroup.value === additionalGroupId,
  )?.data;

  const additionalInputs = useFormInputs<AdditionalProps>();

  return (
    <Creation
      border
      defaultValues={{isFree: false}}
      translationKey={translatedAdditionalGroupConfigProps}
      onFormStateChange={(data) => {
        if (data.additionalGroupId !== additionalGroupId)
          setAdditionalGroupId(data.additionalGroupId);
      }}
      onSubmit={() => useCreateAdditionalGroupConfig(id!)}
      inputs={[
        getSelect({name: 'additionalGroupId', data, isLoading}),
        getSwitch({name: 'isFree'}),
        getNumberInput({name: 'min'}),
        getNumberInput({name: 'max'}),
        getSelect({
          name: 'type',
          data: [
            {label: 'Soma', value: AdditionalGroupConfigTypeEnum.sum},
            {label: 'Média', value: AdditionalGroupConfigTypeEnum.average},
            {
              label: 'Maior valor',
              value: AdditionalGroupConfigTypeEnum.highest_value,
            },
          ],
        }),
        getDynamicSection({
          name: 'additionalPricesWhenFree' as any,
          label: 'Adicionais pagos',
          inputs: [
            additionalInputs.getInput({
              name: 'name',
              gridColumn: 6,
              disabled: true,
            }),
            additionalInputs.getPriceInput({name: 'price', gridColumn: 6}),
          ],
          translationKey: 'AdditionalProps',
          hidden: (data) => !additionals || !data.isFree,
          onCreate: {
            behavior: 'spotlight',
            title: 'Adicionais',
            spotlightOptions: additionals?.map((additional) => ({
              label: additional.name,
              value: additional,
              description: additional.price
                ? toBrl(additional.price)
                : undefined,
            })),
          },
        }),
      ]}
    />
  );
};

export default CreateAdditionalGroupConfig;
